import styled from 'styled-components';

const AdvancedSettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const CharityExtraField = styled.div`
  display: flex;
`;

export { AdvancedSettingsContainer, CharityExtraField };
